import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './styles/prediction-market.css'
import './styles/shared-components.css'
import App from './App'
import './translation/index'
import { Provider } from 'react-redux'
import ErrorBoundary from 'components/ui-kit/ErrorBoundary/index'
import store from 'redux-store/store'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'rc-tooltip/assets/bootstrap_white.css'
import { ThemeProvider } from 'context/ThemeContext'

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <ErrorBoundary>
          <ToastContainer
            position='top-right'
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme='colored'
            style={{ zIndex: 99999 }}
          />
          <App />
        </ErrorBoundary>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

export default store
